import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientAccessModel } from '../../Models/Models/Customer/ClientAccessModel';
import { RoleType } from '../../Constants/Enums/RoleType';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientAccessClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number, clAccountId: string, roleType: RoleType): Promise<ClientAccessModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ClientAccess/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, clAccountId: clAccountId, roleType: roleType }

    return AjaxWrapper.get<ClientAccessModel, any>(url, data);
  }
  public put(clientAccessModel: ClientAccessModel): Promise<ClientAccessModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ClientAccess/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { clientAccessModel: clientAccessModel }

    return AjaxWrapper.put<ClientAccessModel, any>(url, data);
  }
}

